const formatCoins = (coins: number) => {
  if (coins < 1_000) return coins.toFixed(0);
  if (coins < 1_000_000) return `${(coins / 1_000).toFixed(2)}K`;
  if (coins < 1_000_000_000) return `${(coins / 1_000_000).toFixed(2)}M`;
  if (coins < 1_000_000_000_000)
    return `${(coins / 1_000_000_000).toFixed(2)}B`;
  if (coins < 1_000_000_000_000_000)
    return `${(coins / 1_000_000_000_000).toFixed(2)}T`;
  if (coins < 1_000_000_000_000_000_000)
    return `${(coins / 1_000_000_000_000_000).toFixed(2)}q`;
  if (coins < 1_000_000_000_000_000_000_000)
    return `${(coins / 1_000_000_000_000_000_000).toFixed(2)}Q`;
  return coins.toExponential(2);
};

export default formatCoins;
